export const ENV = { ENV: "prod", HOST_BACKEND: "https://apiv3.dareresponse.com" };